export const ID = '88f72d83-138f-4e1f-b441-a73afbb18076';

export const NAME = 'Units Table 1: Standard';
